package com.appsyde.shared.presentation.style.style


import org.jetbrains.compose.web.css.*

object AppStylesLayout : StyleSheet() {

    val container by style {
        maxWidth(1540.px)
        property("margin-left", "auto")
        property("margin-right", "auto")
        padding(28.px)

        display(DisplayStyle.Grid)
        property("grid-template-columns", "280px minmax(0, 1fr) 320px")
        property("align-items", "start")
        gap(24.px)

        media(mediaMaxWidth(980.px)) {
            self style { property("grid-template-columns", "1fr") }
        }
    }

    val globalContentWrap by style {
        property("padding-top", "2px")
    }

    val mainColumn by style {
        minWidth(0.px)

    }

    val sidebar by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(16.px)
    }

    val spacerSm by style { height(20.px) }
    val spacerXs by style { height(10.px) }
    val spacerXxs by style { height(5.px) }

    /** Conteneur page type invitation/workspace : flex colonne pour centrage vertical de la card. */
    val wizardPageWrap by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        property("flex", "1")
        minHeight(0.px)
    }

    /** Zone sous le header : prend la hauteur restante et centre la card verticalement (et horizontalement). */
    val wizardContentWrapCentered by style {
        property("flex", "1")
        minHeight(0.px)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        padding(28.px)
    }

    /** Wizard onboarding : zone sous le header, contenu centré horizontalement (legacy, align top). */
    val wizardContentWrap by style {
        property("flex", "1")
        minHeight(0.px)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.FlexStart)
        padding(28.px)
    }

    /** Une seule card centrale, plus présente (width un poil plus large). */
    val wizardCardWrap by style {
        width(100.percent)
        maxWidth(640.px)
        minWidth(0.px)
    }
}
